import { combineReducers } from 'redux';

import { infringementConfirmationReducer as infringementConfirmation } from 'redpoints-front-infringement-confirmation/InfringementConfirmation';
import { infringementEvaluationReducer as infringementEvaluation } from 'redpoints-front-infringement-evaluation/InfringementEvaluation';

export default combineReducers({
  infringementConfirmation,
  infringementEvaluation,
});
